<template>
  <div class="skill_detail">
    <div class="title">
      <el-button
        class="back-btn"
        type="text"
        icon="el-icon-arrow-left"
        @click="$router.go(-1)"
        >返回</el-button
      >
      <b>技能考核</b>
      <div class="btn export_btn">
        导出数据 <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="main">
      <div class="box_title">我的章节成绩列表</div>
      <div class="works_box">
        <el-table
          class="score-list"
          :data="list"
          row-key="chapterId"
          default-expand-all
          height="calc(748px - 40px - 48px - 105px)"
        >
          <el-table-column
            prop="chapterName"
            label="章节"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>{{ scope.row.chapterName }}</span>
              <el-tag
                v-if="scope.row.sz"
                style="margin-left: 10px"
                effect="dark"
                size="mini"
                >实训</el-tag
              >
              <el-tag
                v-if="scope.row.mock"
                style="margin-left: 10px"
                effect="dark"
                type="warning"
                size="mini"
                >仿真实训</el-tag
              >
              <el-tag
                v-if="scope.row.teamGrade"
                style="margin-left: 10px"
                effect="dark"
                type="success"
                size="mini"
                >评价</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="jnScore"
            label="分数"
            width="120"
            align="center"
          >
          </el-table-column>
        </el-table>
        <!-- <div class="list_title">
          <span>章节</span>
          <span>分数</span>
        </div>
        <div class="list_main">
          <div class="row" v-for="(item, idx) in list" :key="idx">
            <span class="td"
              >{{ getCaption(item.parentChapterName, 0, " ") }} —
              {{ getCaption(item.chapterName, 0, " ")
              }}<el-tag
                v-show="item.sz"
                style="margin-left: 10px"
                effect="dark"
                size="mini"
                >实训</el-tag
              ></span
            >
            <span class="td">{{ item.jnScore }}</span>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { myScore } from "@/api/evaluation";
import { handleTree } from "@/utils/index";

export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$loading.show();
      myScore({
        classId: this.$route.query.id,
        type: "user",
      }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = handleTree(res.data, "chapterId");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.skill_detail {
  height: 748px;
  background-image: url("../../../../assets/images/evaluation_bg.png");
  background-size: cover;
  .title {
    position: relative;
    padding-top: 40px;
    height: 105px;
    text-align: center;
    background-image: url("../../../../assets/images/title_bg1.png");
    background-size: cover;
    .back-btn {
      position: absolute;
      left: 20px;
      top: 13px;
    }
    b {
      letter-spacing: 5px;
      font-size: 30px;
      color: transparent;
      background-image: linear-gradient(180deg, #fff, #fff, #1de0fe, #1de0fe);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .btn {
      position: absolute;
      top: 62px;
      width: 114px;
      height: 32px;
      line-height: 32px;
      color: #fff;
      background-image: url("../../../../assets/images/btn_bg.png");
      cursor: pointer;
      &.export_btn {
        right: 0;
      }
    }
  }
  .main {
    margin: 10px 0;
    .box_title {
      padding: 0 10px;
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      color: #1de0fe;
      background-color: rgba(49, 70, 125, 0.1);
      // border: solid 1px rgba(4, 20, 40, 0.1);
      box-shadow: #6be4f7 0px 0px 5px inset;
    }
    .works_box {
      padding: 10px;
      ::v-deep .score-list {
        background-color: inherit;
        &::before {
          background-color: #1de0fe;
        }
        .el-table__body-wrapper {
          &::-webkit-scrollbar {
            width: 6px;
            background-color: rgb(14, 88, 113);
          }

          &::-webkit-scrollbar-track {
            box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
            -webkit-box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
            background-color: rgb(14, 88, 113);
          }

          &::-webkit-scrollbar-thumb {
            box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
            -webkit-box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
            background-color: #1ae0fe;
          }
        }
        .el-table__expand-icon {
          color: #1de0fe;
        }
        tr,
        th {
          color: #feffff;
          background-color: inherit;
          &:hover {
            td {
              background-color: inherit;
            }
          }
        }
        th {
          color: #1de0fe;
          border-bottom: solid 1px #1de0fe;
        }
        td {
          border-bottom: solid 1px #1de0fe80;
        }
      }

      .list_title {
        padding: 0 32px;
        height: 40px;
        line-height: 40px;
        color: #1de0fe;
        text-align: left;
        background-color: rgba(82, 255, 255, 0.2);
        span {
          display: inline-block;
          text-align: center;
          &:first-child {
            padding-left: 30px;
            width: 80%;
            text-align: left;
          }
          &:nth-child(2) {
            width: 20%;
          }
        }
      }
      .list_main {
        padding: 0 30px 0 32px;
        height: calc(748px - 40px - 48px - 20px - 105px);
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 6px;
          background-color: rgb(14, 88, 113);
        }

        &::-webkit-scrollbar-track {
          box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
          -webkit-box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
          background-color: rgb(14, 88, 113);
        }

        &::-webkit-scrollbar-thumb {
          box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
          -webkit-box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
          background-color: #1ae0fe;
        }
        .row {
          padding: 10px 0 6px;
          line-height: 1.5;
          text-align: left;
          color: #feffff;
          border-bottom: solid 1px transparent;
          border-image: linear-gradient(to right, #1de0fe, transparent) 1 10;
          .td {
            display: inline-block;
            text-align: center;
            &:first-child {
              padding-left: 30px;
              width: 80%;
              text-align: left;
            }
            &:nth-child(2) {
              width: 20%;
            }
          }
        }
      }
    }
  }
}
</style>